import React from "react";
import { DateTimePickerComponent } from './Component';


export class DateTimePicker extends React.PureComponent {
    state = {
        value: this.props.defaultValue,
        mode: this.props.mode || "datetime",
    }

    componentDidUpdate(prevProps) {
        if (this.props.value?.getTime?.() !== prevProps.value?.getTime?.()) {
            this.setState({
                value: this.props.value
            });
        }
    }
    
    onChange = (value, shouldClose) => {
        if (this.state.mode === "datetime") {
            this.setState({ value, mode: "time" });
            return;
        }

        return this.props.onChange?.(value, shouldClose);
    }

    getMode() {
        return this.props.mode || this.state.mode;
    }
    
    render() {
        const { value, ...props } = this.props;

        return <DateTimePickerComponent
            {...props}
            value={value}
            mode={this.state.mode}
            onChange={this.onChange}
        />
    }
}